export let irm_featureDisabled = "VSjJEe";
export let irm_corruptProtectedMessage = "ByuHOb";
export let irm_viewRightNotGranted = "UXgnLb";
export let irm_serverMisConfigured = "rP2lKd";
export let irm_reachNotConfigured = "FxGJ4c";
export let irm_preLicensingFailure = "CKxYw";
export let irm_externalLicensingDisabled = "QVQdge";
export let irm_useLicenseAcquisitionFailed = "zQE4x";
export let irm_rmsErrorCode = "gB_Pn";
export let irm_outlookTrialDownloadUrl = "ZyRFnd";
export let irm_microsoftOfficeOutlook = "GDcsLd";
export let irm_downloadOutlookFreeTrialHtml = "VQKENe";
export default {irm_featureDisabled,irm_corruptProtectedMessage,irm_viewRightNotGranted,irm_serverMisConfigured,irm_reachNotConfigured,irm_preLicensingFailure,irm_externalLicensingDisabled,irm_useLicenseAcquisitionFailed,irm_rmsErrorCode,irm_outlookTrialDownloadUrl,irm_microsoftOfficeOutlook,irm_downloadOutlookFreeTrialHtml};